import {
  type ReviewWidgetBundle,
} from '@thehotelsnetwork/personalization-types';

export function getRankingConfig(config: ReviewWidgetBundle) {
  return {
    visible: !!config.topPercent,
    orLocName: config.orLocName,
    hotelGeoname: config.hotelGeoname,
    hotelLocation: config.hotelLocation,
    topPercentType: config.topPercentType,
    topPercent: config.topPercent,
    hotelType: config.hotelType,
  };
}
